var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component_show_p)?_c('div',{staticClass:"Membership",class:_vm.component_class,on:{"!pointerdown":function($event){return _vm.click_handle.apply(null, arguments)}}},[_c('MembershipLocation'),_c('MembershipLocationPlayerInfo'),_c('MembershipStand'),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }